import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { AppConfigService } from '../../config/app-config.service';
import { AuthService } from '../auth.service';


@Injectable({
    providedIn: "root",
})
export class ProfileClientService {

    private apiUrl: string;
    countryId: number;

    constructor(private http: HttpClient, private auth: AuthService, private configService: AppConfigService) {
        this.apiUrl = configService.value.apiUrl;
        this.countryId = configService.value.countryId;
    }

    // getData(metodo: string): Observable<any> {
    //     const url = `${this.apiUrl}${metodo}`;
    //     return this.http.get(url, this.getRequestOptions());
    //   }


    getData(metodo: string): Observable<any> {

        const url = `${this.apiUrl}${metodo}`;
        return this.auth.getHeaders().pipe(
            switchMap(headers => this.http.get(url, { headers }))
        );
    }

    getAll(): Observable<any[]> {
        const url = `${this.apiUrl}typeclients/actives`;
        return this.auth.getHeaders().pipe(
            switchMap(headers => this.http.get<any[]>(url, { headers }))
        );
    }

    create(data: any): Observable<any> {
        const url = `${this.apiUrl}typeclients`;
        return this.auth.getHeaders().pipe(
            switchMap(headers => this.http.post(url, data, { headers }))
        );
    }

    update(idUser: string, dataUser: any): Observable<any> {
        const url = `${this.apiUrl}typeclients/${idUser}`;
        return this.auth.getHeaders().pipe(
            switchMap(headers => this.http.put(url, dataUser, { headers }))
        );
    }

    delete(id: string): Observable<any> {
        const url = `${this.apiUrl}typeclients/${id}/inactivate`;
        return this.auth.getHeaders().pipe(
            switchMap(headers => this.http.post(url, id, { headers }))
        );
    }







}
